import { useEffect, useRef, useState } from "react"
import { Formik, Field, Form } from "formik"
import {
    InputGroup,
    FieldWrappers,
    Label,
    SubmitBtn,
    Wrapper,
    CombineInputGroup,
    ActionSection,
    ScrollableContent,
} from "../Styles/InputStyles"
import { toast } from "react-toastify"
import { MdClose } from "react-icons/md"
import tw from "tailwind-styled-components"
import Images from "../../Images"
import PayerDropdown from "../PayerDropdown"
import Dropdown from "react-dropdown"
import moment from "moment"
import "react-datepicker/dist/react-datepicker.css";
import DropZone from "../Notice/Dropzone"
import DateModal from "./DateModal"
import { Box } from "@mui/material"
import NewPayerDropdown from "../NewPayerDropdown"
import CategoryCard from "../CategoryCard"
import SelectCategoryModal from "./SelectCategoryModal"
import PaidUserModal from "./PaidUserModal"
import PaidToUserModal from "./PaidToUserModal"
import SinglePropSelectModal from "../SinglePropSelectModal"
import { paymentModes } from "../../helpers"

const EditExpenses = ({
    handleClose,
    selectedData,
    editExpenseMutate,
    editExpenseLoading,
    expenseData,
    categories,
    property
}) => {
    const formikRef = useRef(null);
    const [showDateRepetitionModal, setShowDateRepetitionModal] = useState(false)
    const [showCategoryModal, setShowCategoryModal] = useState(false)
    const [showPaidByModal, setShowPaidByModal] = useState(false)
    const [showPaidToModal, setShowPaidToModal] = useState(false)
    const [showPropertyModal, setShowPropertyModal] = useState(false)
    const [userValues, setUserValues] = useState({
        amount: selectedData?.amount || "",
        paymentDate: selectedData?.paidDate ? moment(selectedData.paidDate).format("YYYY-MM-DD") : "",
        repetition: selectedData?.repetitionType || "",
        description: selectedData?.description || "",
        paymentMode: selectedData?.paymentMethod || "",
        file: selectedData?.supportDoc || null,
    })

    const [selectedPaidBy, setSelectedPaidBy] = useState(null);
    const [selectedPaidTo, setSelectedPaidTo] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedProperty, setSelectedProperty] = useState(null);
    const [isInitialized, setIsInitialized] = useState(false);
    const [height, setHeight] = useState(window.innerHeight);

    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight);
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        if (selectedData && property) {
            const paidByUser = expenseData?.users?.find((user) => user.id == selectedData.paidBy)
            const paidToVendor = expenseData?.vendors?.find((vendor) => vendor.id == selectedData.paidTo)
            let categoryOption = null
            categories?.forEach((categoryGroup) => {
                const match = categoryGroup.items.find((item) => item.value == selectedData.type)
                if (match) categoryOption = match
            })
            const propertyOption = selectedData?.propertyList[0]?.id
                ? property.find((prop) => prop.id == selectedData.propertyList[0].id)
                : null;

            setSelectedPaidBy(paidByUser || null)
            setSelectedPaidTo(paidToVendor || null)
            setSelectedCategory(categoryOption || null)
            setSelectedProperty(propertyOption || null)

            if (!isInitialized) {
                setUserValues({
                    amount: selectedData?.amount || "",
                    paymentDate: selectedData?.paidDate ? moment(selectedData.paidDate).format("YYYY-MM-DD") : "",
                    repetition: selectedData?.repetitionType || "",
                    description: selectedData?.description || "",
                    paymentMode: selectedData?.paymentMethod || "",
                    file: selectedData?.supportDoc || null,
                })
                setIsInitialized(true)
            }
        }
    }, [selectedData, expenseData, categories, isInitialized, property])

    const handleFormChange = (e) => {
        if (e && e.target) {
            const { name, value } = e.target
            if (name && (name === "amount" || name === "paymentDate" || name === "description")) {
                setUserValues((prev) => ({
                    ...prev,
                    [name]: value,
                }))
            }
        }
    }

    const initialValues = {
        amount: userValues.amount,
        category: selectedCategory?.value || "",
        repetition: userValues.repetition,
        paymentDate: userValues.paymentDate,
        property: selectedProperty?.id || "",
        paidBy: selectedPaidBy?.id || "",
        paidTo: selectedPaidTo?.id || "",
        paymentMode: userValues.paymentMode,
        description: userValues.description,
        expenseId: selectedData?.id,
        file: selectedData?.supportDoc,
    }

    const repetition = [
        { value: 1, label: "One Time" },
        { value: 2, label: "Monthly" },
    ]

    // const paymentModes = [
    //     {
    //         value: 1,
    //         label: "Offline",
    //         icon: <img src={Images.Offline || "/placeholder.svg"} alt="Offline" className="w-10 h-10" />,
    //     },
    //     {
    //         value: 2,
    //         label: "UPI",
    //         icon: <img src={Images.UPI || "/placeholder.svg"} alt="UPI" className="w-10 h-10" />,
    //     },
    //     {
    //         value: 3,
    //         label: "Net Banking",
    //         icon: <img src={Images.Netbanking || "/placeholder.svg"} alt="Net Banking" className="w-10 h-10" />,
    //     },
    //     {
    //         value: 4,
    //         label: "Card",
    //         icon: <img src={Images.Card || "/placeholder.svg"} alt="Card" className="w-10 h-10" />,
    //     },
    // ]

    const handleSelectedPaidBy = (selectedOption) => {

        setSelectedPaidBy(selectedOption)
        if (formikRef.current) {
            formikRef.current.setFieldValue("paidBy", selectedOption.id)
            formikRef.current.setFieldValue("paidByUserType", selectedOption.userType)
        }
    }

    const handleSelectedPaidTo = (selectedOption) => {
        setSelectedPaidTo(selectedOption)
        if (formikRef.current) {
            formikRef.current.setFieldValue("paidTo", selectedOption.id)
            formikRef.current.setFieldValue("paidToUserType", selectedOption.userType)
        }
    }

    const handleSelectedCategory = (selectedOption) => {
        setSelectedCategory(selectedOption)
        if (formikRef.current) {
            formikRef.current.setFieldValue("category", selectedOption.value)
        }
    }

    // const handleSelectedProperty = (selectedOption) => {
    //     // Find the actual property object from the property array
    //     const propertyObj = property.find(prop => prop.id == selectedOption.value);
    //     setSelectedProperty(propertyObj);
    //     if (formikRef.current) {
    //         formikRef.current.setFieldValue("property", selectedOption.value)
    //     }
    // }

    const handleSelectedProperty = (selectedOption) => {
        setSelectedProperty(selectedOption);
        if (formikRef.current) {
            formikRef.current.setFieldValue("property", selectedOption.id)
        }
    }

    const handlePaymentModeChange = (value) => {
        setUserValues((prev) => ({
            ...prev,
            paymentMode: value,
        }))
        if (formikRef.current) {
            formikRef.current.setFieldValue("paymentMode", value)
        }
    }

    const handleSubmit = (values) => {
        const amountRegex = /^(?!0+$)\d{1,6}$/
        const maxAmount = 1000000

        if (!amountRegex.test(values.amount) || Number.parseInt(values.amount) > maxAmount) {
            toast.error("Monthly rent must be between 1 and 10,00,000 and contain only numbers")
            return
        }

        if (!values.category) {
            toast.error("Category is required")
            return
        }
        if (!values.repetition) {
            toast.error("Repetition is required")
            return
        }
        if (!values.paymentDate) {
            toast.error("Payment date is required")
            return
        }
        if (!values.paidBy) {
            toast.error("Paid by is required")
            return
        }
        if (!values.paidTo) {
            toast.error("Paid to is required")
            return
        }
        if (!values.paymentMode) {
            toast.error("Payment mode is required")
            return
        }

        const formData = new FormData();
        formData.append("amount", Number(values.amount));
        formData.append("type", Number(values.category));
        formData.append("repetitionType", Number(values.repetition));
        formData.append("description", values.description);
        formData.append("paidDate", moment(values.paymentDate).format("YYYY-MM-DDTHH:mm:ss[Z]"));
        formData.append("paidBy", Number(values.paidBy));
        formData.append("paidTo", Number(values.paidTo));
        formData.append("paymentMode", values.paymentMode);
        formData.append("propertyId", Number(values.property));
        formData.append("paidByUserType", Number(selectedPaidBy.userType));
        formData.append("paidToUserType", Number(selectedPaidTo.userType));
        formData.append("expenseId", Number(selectedData.id));
        if (values.file) {
            formData.append("file", values.file[0])
        }
        editExpenseMutate(formData);
    }

    const handleDateRepetitionSave = (date) => {
        if (formikRef.current) {
            formikRef.current.setFieldValue("paymentDate", date)
        }
    }

    const propertyOptions = property?.map(prop => ({
        value: prop.id,
        label: prop.name
    })) || [];

    const formattedSelectedProperty = selectedProperty ? {
        value: selectedProperty.id,
        label: selectedProperty.name
    } : null;

    return (
        <Container style={{ height: `${height}px`, overflow: 'auto', WebkitOverflowScrolling: 'touch' }}>
            <Header>
                <h1 className="text-white text-lg font-medium">Edit Expense</h1>
                <button onClick={handleClose}>
                    <MdClose color="white" size={24} />
                </button>
            </Header>

            <div className="px-6 h-full flex flex-col justify-between">
                <Formik
                    innerRef={formikRef}
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                    enableReinitialize
                >
                    {({ values, setFieldValue, handleChange, handleBlur, errors, touched }) => (
                        <Form onChange={handleFormChange}>
                            <ScrollableContent className="max-h-[calc(100vh-140px)]">
                                <Wrapper>
                                    <InputGroup>
                                        <Label htmlFor="category">Category *</Label>
                                        <CategoryCard
                                            title="Category"
                                            selectedCategory={selectedCategory}
                                            onClick={() => setShowCategoryModal(true)}
                                        />
                                    </InputGroup>
                                    <CombineInputGroup>
                                        <InputGroup>
                                            <Label htmlFor="amount">Amount *</Label>
                                            <FieldWrappers>
                                                <Field
                                                    type="text"
                                                    name="amount"
                                                    id="amount"
                                                    className={`w-full truncate`}
                                                    value={userValues.amount}
                                                    onChange={(e) => {
                                                        handleChange(e)
                                                        setUserValues((prev) => ({
                                                            ...prev,
                                                            amount: e.target.value,
                                                        }))
                                                        setFieldValue("amount", e.target.value)
                                                    }}
                                                />
                                            </FieldWrappers>
                                        </InputGroup>
                                    </CombineInputGroup>
                                    {/* <CombineInputGroup> */}
                                    <InputGroup>
                                        <Label htmlFor="paidBy">Paid by *</Label>
                                        <CategoryCard
                                            title="Paid By"
                                            selectedCategory={selectedPaidBy}
                                            onClick={() => setShowPaidByModal(true)}
                                        />

                                    </InputGroup>
                                    <InputGroup>
                                        <Label htmlFor="paidTo">Paid to *</Label>
                                        <CategoryCard
                                            title="Paid to"
                                            selectedCategory={selectedPaidTo}
                                            onClick={() => setShowPaidToModal(true)}
                                        />

                                    </InputGroup>

                                    <InputGroup>
                                        <Label>Select property </Label>
                                        <CategoryCard
                                            title="Property"
                                            selectedCategory={selectedProperty}
                                            onClick={() => setShowPropertyModal(true)}
                                        />
                                    </InputGroup>
                                    <InputGroup>
                                        <Label>Payment Mode *</Label>
                                        <PaymentModeWrapper>
                                            {paymentModes.map((mode) => (
                                                <PaymentModeCard
                                                    key={mode.value}
                                                    type="button"
                                                    onClick={(e) => {
                                                        e.preventDefault()
                                                        setFieldValue("paymentMode", mode.value)
                                                        handlePaymentModeChange(mode.value)
                                                    }}
                                                    className={`${userValues.paymentMode === mode.value ? "bg-primary-color text-white" : "bg-gray-100"
                                                        } `}
                                                >
                                                    <span className="text-sm">{mode.label}</span>
                                                </PaymentModeCard>
                                            ))}
                                        </PaymentModeWrapper>
                                    </InputGroup>

                                    <InputGroup>
                                        <Label htmlFor="description">Description </Label>
                                        <Field
                                            as={Textarea}
                                            id="description"
                                            name="description"
                                            rows={5}
                                            placeholder="Enter Description"
                                            value={userValues.description}
                                            onChange={(e) => {
                                                handleChange(e)
                                                setUserValues((prev) => ({
                                                    ...prev,
                                                    description: e.target.value,
                                                }))
                                                setFieldValue("description", e.target.value)
                                            }}
                                        />
                                    </InputGroup>
                                    <InputGroup>
                                        <Label htmlFor="file">
                                            Document(optional)
                                        </Label>
                                        <FieldWrapper $select={true}>
                                            <Field
                                                required
                                                name="file"
                                                type="text"
                                                id="file"
                                                autoComplete="off"
                                            >
                                                {(props) => (
                                                    <DropZone
                                                        fields={props.field}
                                                        setFieldValue={props.form.setFieldValue}
                                                        componentFor="expense"
                                                        acceptedFiles="image/*,application/pdf"
                                                        File={props.field.value ? [props.field.value] : null}
                                                    />
                                                )}
                                            </Field>
                                        </FieldWrapper>
                                    </InputGroup>
                                </Wrapper>
                            </ScrollableContent>
                            <ActionSection>
                                <ExpenseDateRepetitionBtn type="button" onClick={() => setShowDateRepetitionModal(true)}>
                                    Expense Date / Repetition
                                    <div className="text-sm text-gray-800 mt-1">
                                        {values.paymentDate
                                            ? moment(values.paymentDate).format("YYYY-MM-DD")
                                            : ""}
                                        {" / "}
                                        {values.repetition === 1
                                            ? "One Time"
                                            : values.repetition === 2
                                                ? "Monthly"
                                                : ""}
                                    </div>
                                </ExpenseDateRepetitionBtn>
                                <SubmitBtn type="submit" disabled={editExpenseLoading}>
                                    {editExpenseLoading ? "Loading..." : "Submit"}
                                </SubmitBtn>
                            </ActionSection>
                            <DateModal
                                isOpen={showDateRepetitionModal}
                                onClose={() => setShowDateRepetitionModal(false)}
                                onSave={handleDateRepetitionSave}
                                initialDate={values.paymentDate}
                            />
                            <SelectCategoryModal
                                isOpen={showCategoryModal}
                                onClose={() => setShowCategoryModal(false)}
                                onSelect={handleSelectedCategory}
                                categories={categories}
                                selectedCategory={selectedCategory}
                            />
                            <PaidUserModal
                                isOpen={showPaidByModal}
                                onClose={() => setShowPaidByModal(false)}
                                onSelect={handleSelectedPaidBy}
                                options={expenseData?.users}
                                selectedPaidBy={selectedPaidBy}
                            />
                            <PaidToUserModal
                                isOpen={showPaidToModal}
                                onClose={() => setShowPaidToModal(false)}
                                onSelect={handleSelectedPaidTo}
                                options={expenseData?.vendors}
                                landlordList={expenseData?.landlords}
                                selectedPaidTo={selectedPaidTo}
                                title="Select Paid To"
                            />
                            <SinglePropSelectModal
                                isOpen={showPropertyModal}
                                onClose={() => setShowPropertyModal(false)}
                                onSelect={handleSelectedProperty}
                                options={property}
                                selectedProperty={selectedProperty}
                            />
                        </Form>
                    )}
                </Formik>
            </div>
        </Container>
    )
}

const FieldWrapper = tw.div`w-full`;
const Container = tw.div`bg-white w-full h-full flex flex-col relative`
const Header = tw.div`flex items-center justify-between bg-[#26A69A] py-4 px-4`
const Textarea = tw.textarea`min-h-10 max-h-40 border border-gray-300 rounded pl-2 py-2 focus:ring-1 focus:ring-sky-600  focus:border-sky-600 focus:outline-none duration-200 w-full h-20 resize-y  break-words overflow-hidden`
const PaymentModeWrapper = tw.div`grid grid-cols-4 gap-2 my-1.5`
const PaymentModeCard = tw.button`flex flex-col items-center justify-center p-2 border rounded-lg shadow-sm cursor-pointer`
const ExpenseDateRepetitionBtn = tw.button`
  flex items-center justify-center flex-col
  px-4 py-2
  text-sm font-medium text-gray-600
  bg-white 
  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500
  disabled:opacity-50
`

export default EditExpenses
